import { Component, OnInit } from '@angular/core';
import {UserModel} from '../../api/user-model';
import {ActivatedRoute, Router} from '@angular/router';
import { showSpinner, hideSpinner } from '@syncfusion/ej2-popups';
import {UsersService} from '../../api/users.service';
import {FilterStorageService} from '../../services/filter-storage.service';
import {UpdateUserRequestModel} from '../../api/update-user-request-model';

@Component({
  selector: 'app-user-edit',
  templateUrl: './user-edit.component.html',
  styleUrls: ['./user-edit.component.scss']
})
export class UserEditComponent implements OnInit {
  user: UpdateUserRequestModel;
  routeUser: UserModel;

  constructor(private route: ActivatedRoute,
              private router: Router,
              private users: UsersService,
              private filters: FilterStorageService) { }

  ngOnInit() {
    this.route.data
      .subscribe((data: { user: UserModel }) => {
        console.log(data);
        this.routeUser = data.user;
        this.user = {
          executorId: 'notemptystring',
          appFeatures: this.routeUser.appFeatures,
          externalId: this.routeUser.externalID,
          firstName: this.routeUser.firstName,
          lastName: this.routeUser.lastName,
          roleId: this.routeUser.roleID,
          rptFeatures: this.routeUser.rptFeatures,
        };
      });
  }

  async saveData() {
    showSpinner(document.getElementById('wrapper')) ;

    try {
      await this.users.update(this.filters.getSelectedOrganization().id, this.routeUser.id, this.user).toPromise();
      this.goBack();
    } catch (e) {
      alert(e.error.message);
      console.error(e);
    } finally {
      hideSpinner(document.getElementById('wrapper'));
    }
  }

  goBack() {
    this.router.navigate(['../..'], {relativeTo: this.route});
  }
}
